import React, { useState } from 'react';
import { motion } from 'framer-motion';
import Header from './components/Header';
import SearchForm from './components/SearchForm';
import PopularDestinations from './components/PopularDestinations';
import VehicleSelector from './components/VehicleSelector';
import DriverCard from './components/DriverCard';
import { availableDrivers } from './mock/drivers';

const App = () => {
  const [searchResults, setSearchResults] = useState(null);
  const [selectedVehicle, setSelectedVehicle] = useState(null);

  const handleSearch = (searchData) => {
    console.log('Búsqueda realizada:', searchData);
    setSearchResults(searchData);
  };

  const handleVehicleSelect = (vehicle) => {
    setSelectedVehicle(vehicle);
    console.log('Vehículo seleccionado:', vehicle);
  };

  const handleDriverSelect = (driver) => {
    console.log('Conductor seleccionado:', driver);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 via-blue-50 to-cyan-50">
      <Header />
      
      <main className="container mx-auto px-4 py-8 space-y-12">
        {/* Hero Section */}
        <motion.section 
          className="text-center py-12"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <motion.h1 
            className="text-4xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-green-600 via-blue-600 to-cyan-600 bg-clip-text text-transparent"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            Explora Costa Rica
          </motion.h1>
          <motion.p 
            className="text-xl text-gray-600 max-w-3xl mx-auto mb-8"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            Transporte seguro y confiable hacia los destinos más hermosos del país. 
            Desde playas paradisíacas hasta volcanes majestuosos, te llevamos donde quieras ir.
          </motion.p>
        </motion.section>

        {/* Search Form */}
        <SearchForm onSearch={handleSearch} />

        {/* Vehicle Selection */}
        {searchResults && (
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <VehicleSelector 
              basePrice={45000}
              passengers={searchResults.passengers}
              onSelect={handleVehicleSelect}
            />
          </motion.div>
        )}

        {/* Available Drivers */}
        {selectedVehicle && (
          <motion.section
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <div className="text-center mb-8">
              <h3 className="text-2xl font-bold text-gray-800 mb-4">
                Conductores Disponibles
              </h3>
              <p className="text-gray-600">
                Selecciona tu conductor preferido para el viaje
              </p>
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {availableDrivers.map((driver, index) => (
                <DriverCard
                  key={driver.id}
                  driver={driver}
                  onSelect={handleDriverSelect}
                  index={index}
                />
              ))}
            </div>
          </motion.section>
        )}

        {/* Popular Destinations */}
        <PopularDestinations />

        {/* Features Section */}
        <motion.section 
          className="py-12"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        >
          <div className="bg-white/80 backdrop-blur-xl border border-gray-200/50 rounded-3xl p-12 shadow-xl">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-bold text-gray-800 mb-4">
                ¿Por qué elegir TuriCosta?
              </h2>
              <p className="text-gray-600 max-w-2xl mx-auto">
                Ofrecemos la mejor experiencia de transporte turístico en Costa Rica
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {[
                {
                  icon: '🚗',
                  title: 'Vehículos Modernos',
                  description: 'Flota nueva y bien mantenida para tu comodidad y seguridad'
                },
                {
                  icon: '👨‍✈️',
                  title: 'Conductores Expertos',
                  description: 'Guías locales con amplio conocimiento del país'
                },
                {
                  icon: '⭐',
                  title: 'Servicio Premium',
                  description: 'Atención personalizada y experiencias inolvidables'
                }
              ].map((feature, index) => (
                <motion.div
                  key={index}
                  className="text-center p-6"
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.8 + index * 0.1 }}
                >
                  <div className="text-4xl mb-4">{feature.icon}</div>
                  <h3 className="text-xl font-bold text-gray-800 mb-3">{feature.title}</h3>
                  <p className="text-gray-600">{feature.description}</p>
                </motion.div>
              ))}
            </div>
          </div>
        </motion.section>
      </main>

      {/* Footer */}
      <motion.footer 
        className="bg-gray-800 text-white py-12 mt-20"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.8, delay: 1 }}
      >
        <div className="container mx-auto px-4 text-center">
          <h3 className="text-2xl font-bold mb-4">TuriCosta</h3>
          <p className="text-gray-400 mb-6">
            Tu compañero de confianza para explorar Costa Rica
          </p>
          <p className="text-sm text-gray-500">
            © 2025 TuriCosta. Todos los derechos reservados. Pura Vida! 🇨🇷
          </p>
        </div>
      </motion.footer>
    </div>
  );
};

export default App;